import React, { useState, useEffect } from 'react';
import ApiService from '../services/apiService';
import './PaymentHistory.css';

const PaymentHistory = ({ userId }) => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const limit = 10;

  useEffect(() => {
    loadPayments();
  }, [userId, page]);

  const loadPayments = async () => {
    try {
      setLoading(true);
      const payments = await ApiService.getPaymentsSupabase(userId, limit, page * limit);
      if (page === 0) {
        setPayments(payments);
      } else {
        setPayments(prev => [...prev, ...payments]);
      }
      setHasMore(payments.length === limit);
    } catch (error) {
      console.error('Failed to load payments:', error);
      setError('Ошибка загрузки истории платежей');
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => {
    if (!loading && hasMore) {
      setPage(prev => prev + 1);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return '#4CAF50';
      case 'pending':
        return '#FF9800';
      case 'failed':
        return '#F44336';
      case 'cancelled':
        return '#9E9E9E';
      default:
        return '#9E9E9E';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'Завершен';
      case 'pending':
        return 'В обработке';
      case 'failed':
        return 'Ошибка';
      case 'cancelled':
        return 'Отменен';
      default:
        return status;
    }
  };

  const getPaymentMethodText = (method) => {
    switch (method) {
      case 'telegram':
        return 'Telegram Bot';
      case 'ton_wallet':
        return 'TON Wallet';
      case 'manual':
        return 'Ручное пополнение';
      default:
        return method;
    }
  };

  if (error) {
    return (
      <div className="payment-history-error">
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>
          Попробовать снова
        </button>
      </div>
    );
  }

  return (
    <div className="payment-history">
      <h3 className="payment-history-title">История платежей</h3>
      
      {payments.length === 0 && !loading ? (
        <div className="payment-history-empty">
          <p>История платежей пуста</p>
        </div>
      ) : (
        <div className="payment-history-list">
          {payments.map((payment) => (
            <div key={payment.id} className="payment-history-item">
              <div className="payment-history-item-header">
                <div className="payment-history-amount">
                  <span className="payment-currency">
                    {payment.currency === 'stars' ? '⭐' : '💎'}
                  </span>
                  <span className="payment-amount">
                    {payment.amount} {payment.currency === 'stars' ? 'звезд' : 'TON'}
                  </span>
                </div>
                <div 
                  className="payment-status"
                  style={{ color: getStatusColor(payment.status) }}
                >
                  {getStatusText(payment.status)}
                </div>
              </div>
              
              <div className="payment-history-item-details">
                <div className="payment-method">
                  {getPaymentMethodText(payment.paymentMethod)}
                </div>
                <div className="payment-date">
                  {formatDate(payment.createdAt)}
                </div>
              </div>
              
              {payment.transactionId && (
                <div className="payment-transaction-id">
                  ID: {payment.transactionId.slice(0, 8)}...
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {loading && (
        <div className="payment-history-loading">
          Загрузка...
        </div>
      )}
      
      {hasMore && !loading && payments.length > 0 && (
        <button 
          className="payment-history-load-more"
          onClick={loadMore}
        >
          Загрузить еще
        </button>
      )}
    </div>
  );
};

export default PaymentHistory; 